AOS.init();

var collection_product = $(".products-on-page"); //products_on_page
var next_url = collection_product.data("next-url");
var load_more_btn = $(".load-more_btn ");
var load_more_spinner = $(".load-more_spinner");

function loadMoreProducts() {
  $.ajax({
    url: next_url,
    type: "GET",
    dataType: "html",
    beforeSend: function () {
      $(".facetwp-load-more").html("Loading...");
      load_more_spinner.show();
    },
  }).done(function (next_page) {
    load_more_btn.hide();
    load_more_spinner.hide();

    var new_products = $(next_page).find(".products-on-page");
    var new_url = new_products.data("next-url");

    if (new_url) {
      $(".facetwp-load-more").html("Load more");
      load_more_btn.show();
    }
    next_url = new_url;
    collection_product.append(new_products.html());
  });
}

// Recover password page redirect url js

function recover() {
  window.location.href = "#recover";
}
function cancle() {
  window.location.href = "#login";
}

// END

$(document).ready(function () {
  /* cart product flip :Start */
  $(".flip_back").click(function () {
    $(this)
      .closest(".flips-box-product-card")
      .find(".flips-box-card")
      .addClass("is-flipped");
  });
  $(".flip_box_reverse").click(function () {
    $(this)
      .closest(".flips-box-product-card")
      .find(".flips-box-card")
      .removeClass("is-flipped");
  });

  $(".purchase_sub_option").click(function () {
    $(".purchase_sub_option").removeClass("active");
    $(this).addClass("active");
    var plan_name = $(this).find(".option_input").data("sub_pan");

    if (typeof plan_name !== "undefind" && plan_name != "") {
      if (plan_name == "one_time") {
        $(this).closest(".subscription-product").find(".selling_plan").val(" ");
        $(this)
          .closest(".form")
          .find(".add_to_card_price")
          .html($(this).find(".option_input").data("plan_price"));
      } else {
        let sell_ID = $(this).find(".option_input").attr("id");
        $(this)
          .closest(".subscription-product")
          .find(".selling_plan")
          .val(sell_ID);
        $(this)
          .closest(".form")
          .find(".add_to_card_price")
          .html($(this).find(".option_input").data("plan_price"));
      }
    }
  });
  /* cart product flip : End */

  // Sticky Header js
  jQuery(window).scroll(function () {
    var bundleSection = jQuery(".azo_bundle_wrapper");
    if (bundleSection.length === 0) {
      if (jQuery(this).scrollTop() > 40) {
        jQuery(".section-header").addClass("sticky_header");
      } else {
        jQuery(".section-header").removeClass("sticky_header");
      }
    }
  });

  function updateOverlayNav() {
    if (window.innerWidth <= 991) {
      var headerHeight = jQuery(".section-header").outerHeight() || 0;
      var announcementHeight = jQuery(".annoucement_bar").outerHeight() || 0;
      var totalHeight = headerHeight + announcementHeight;
      var announceHeight = "calc(100vh - " + announcementHeight + "px)";
      var navHeight = "calc(100vh - " + totalHeight + "px)";
      if (jQuery(window).scrollTop() > 40) {  
        jQuery(".overlay-navigation").css({
          "max-height": announceHeight,
          "min-height": announceHeight,
          "top": headerHeight + "px",
        });
      } else {
        jQuery(".overlay-navigation").css({
          "max-height": navHeight,
          "min-height": navHeight,
          "top": totalHeight + "px",
        });
      }
    } else {
         jQuery(".overlay-navigation").css({
          "max-height": "unset" ,
          "min-height": "unset",
          "top": totalHeight + "px",
        });
    }
  }

  jQuery(window).on("scroll resize", updateOverlayNav);

  setTimeout(function () {
    updateOverlayNav();
  }, 300);

  // $(".overlay-navigation").css({
  //     "max-height": "unset" ,
  //     "min-height": "unset",
  //     "top": totalHeight + "px",
  //   });
    
  // hotspot js
  $(".hotspot-banner-icon").click(function () {
    $(".hotspot-content").show();
  });

  $(".hotspot-close-icon").click(function () {
    $(".hotspot-content").hide();
  });

  // js for popup in betches-dev page for richtext section
  $(
    ".rich-text .rich-text__blocks .rich-text__buttons.lightbox_trigger .button"
  ).on("click", function (e) {
    e.preventDefault();
    $(".lightbox_popup").addClass("active_popup");
  });

  $(".lightbox_popup .lightbox_popup_cancel_btn svg").click(function () {
    $(".lightbox_popup").removeClass("active_popup");
  });

  if (typeof allBrands != "undefined" && !allBrands.ready) {
    $(
      '<a href="#" class="mb-0 text-decoration-none d-block open-fob-mobile  fw-500">' +
        allBrands.title +
        "</a>"
    ).appendTo(".fob-mobile");
    let brandsMenu = $(
      '<div class="brands-list" style="display: none;"></div>'
    );
    allBrands.brands.forEach(function (brand) {
      $(
        '<a class="d-block" target="_blank" href="' +
          brand.url +
          '" style="background-image: url(' +
          brand.product +
          ')">' +
          '<img src=" ' +
          brand.logo +
          '" alt="' +
          brand.title +
          '">' +
          brand.description +
          "</a>"
      ).appendTo(brandsMenu);
    });
    brandsMenu.appendTo($(".fob-mobile"));
    allBrands.ready = true;
    $(".open-fob-mobile").on("click", function (e) {
      e.preventDefault();
      $(".brands-list").slideToggle();
      $(this).toggleClass("open");
    });
    $(".has-mega-menu").on("click", function () {
      $(".brands-list").slideUp();
      $(".open-fob-mobile").removeClass("open");
    });
  }

  // Rebuy application stop js

  setInterval(function () {
    $("body.rebuy-modal-visible").removeClass("rebuy-modal-visible");
    $(".cart-item").each(function () {
      if ($(this).find(".oneTimeOnly").attr("style")) {
        $(this)
          .find(".qun_reg_price.visually-hidden")
          .removeClass("visually-hidden");
      }
    });
  }, 1000);

  // when click add to cart button then show loading sppiner

  $(".product-form__submit").click(function () {
    $(".loading-overlay__spinner").removeClass("hidden");
  });

  // Redeem Free Products

  let debounceTimer;

  setInterval(function () {
    let cartRedeemFreeGift = parseFloat(
      $(".cart-redeem-free-gift").attr("data-total-price")
    );
    let cartTotalPrice = parseFloat(
      $(".drawer__footer").attr("total-cart-price")
    );

    function getQuantity() {
      let totalQuantity = 0;
      $(".cart-item.redeem-product-item .quantity__input").each(function () {
        totalQuantity += parseInt($(this).val()) || 0;
      });
      return totalQuantity;
    }

    function removeLastRedeemItem() {
      if ($(".redeem-product-item").length > 0) {
        $(".redeem-product-item .cartDrawer_Remove").last().click();
      }
    }

    function decreaseFreeProductQuantity() {
      $(".redeem-product-item").each(function () {
        let quantity = parseInt($(this).find(".quantity__input").val());
        if (quantity > 1) {
          $(this).find('.quantity__button[name="minus"]').click();
        }
      });
    }

    function debounce(fn, delay) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(fn, delay);
    }

    debounce(function () {
      if (cartTotalPrice < 2500) {
        removeLastRedeemItem();
      }
      if (cartRedeemFreeGift < 2500) {
        $(".cart-redeem-free-gift").hide();
      }
      if (cartRedeemFreeGift >= 2500 && cartRedeemFreeGift < 5000) {
        $(".cart-redeem-free-gift").show();
        $(".cart-redeem-free-gift .reddem-free-gift").show();
        if (getQuantity() > 0) {
          $(".free-product-heading")
            .html($(".free-product-heading").attr("data-sucess"))
            .addClass("product_redeemed");
          $(".cart-redeem-free-gift .reddem-free-gift").hide();
        }
        if (getQuantity() > 1) {
          if ($(".redeem-product-item").length > 1) {
            removeLastRedeemItem();
          } else {
            decreaseFreeProductQuantity();
          }
        }
      }

      if (cartRedeemFreeGift >= 5000 && cartRedeemFreeGift < 7500) {
        $(".cart-redeem-free-gift").show();
        $(".cart-redeem-free-gift .reddem-free-gift").show();
        $(".free-product-heading").addClass("product_redeemed");

        if (getQuantity() > 1) {
          $(".free-product-heading")
            .html($(".free-product-heading").attr("data-sucess"))
            .addClass("product_redeemed");
          $(".cart-redeem-free-gift .reddem-free-gift").hide();
        }

        if (getQuantity() > 2) {
          if ($(".redeem-product-item").length > 1) {
            removeLastRedeemItem();
          } else {
            decreaseFreeProductQuantity();
          }
        }
      }

      if (cartRedeemFreeGift >= 7500) {
        $(".cart-redeem-free-gift").show();
        $(".cart-redeem-free-gift .reddem-free-gift").show();
        $(".free-product-heading").addClass("product_redeemed");

        if (getQuantity() > 2) {
          $(".free-product-heading")
            .html($(".free-product-heading").attr("data-sucess"))
            .addClass("product_redeemed");
          $(".cart-redeem-free-gift .reddem-free-gift").hide();
        }

        if (getQuantity() > 3) {
          if ($(".redeem-product-item").length > 2) {
            removeLastRedeemItem();
          } else {
            decreaseFreeProductQuantity();
          }
        }
      }

      var freeGiftHandles = [];
      $(".redeem-free-gift .freeGiftHandle").each(function () {
        freeGiftHandles.push($(this).val());
      });

      $(".cart-items .cart-item").each(function () {
        var productHandle = $(this)
          .find(".cart-item__details")
          .attr("data-product-handle");

        if (freeGiftHandles.includes(productHandle)) {
          $(this).addClass("redeem-product-item");
          $(".cart-items")
            .find(".cart-item__quantity-wrapper")
            .addClass("redeem-free-gift-wrapper");
          $(this).find(".product-subscription-section").remove();
          $(this).find(".free-color").remove();
          $(this).find(".quantity__button").css("visibility", "hidden");
          $(this)
            .find(".cart-item__quantity-wrapper .cart-item__totals")
            .before('<p class="free-color">Free Gift</p>');
        }

        // Check for .discount-message class and mark as bundle product
        if ($(this).find(".discount-message").length) {
          $(this).addClass("bundle-product");
        } else {
          $(this).removeClass("bundle-product");
        }
      });
    }, 500);
  }, 1000);
});

setInterval(() => {
  const allRows = document.querySelectorAll(".cart-items tbody tr");
  const redeemRows = document.querySelectorAll(
    ".cart-items tbody tr.redeem-product-item"
  );
  const giftcardRows = document.querySelectorAll(
    ".cart-items tbody tr.giftcard_product"
  );
  const cartRows = document.querySelectorAll(
    ".cart-items tbody tr:not(.redeem-product-item):not(.giftcard_product)"
  );

  if (
    redeemRows.length >= 1 &&
    giftcardRows.length >= 1 &&
    cartRows.length === 0
  ) {
    redeemRows[0].classList.add("wps-btn-checkout");
    redeemRows.forEach((row) => {
      const removeButton = row.querySelector(".cartDrawer_Remove");
      if (removeButton) {
        removeButton.click();
      }
    });
  }
}, 1000);



// document.addEventListener("DOMContentLoaded", function () {
//   const section4 = document.getElementById("theme_section-template--15328510509105__section_bA9qqM");

//   if (section4) {
//     // Find all accordions inside this section4
//     const accordions = section4.querySelectorAll(".azo_accordion");

//     // Check if ALL accordions are empty (title and content)
//     let allEmpty = true;

//     accordions.forEach(acc => {
//       const title = acc.querySelector(".azo_accordion_title");
//       const content = acc.querySelector(".azo_accordion_content");

//       const titleEmpty = !title || title.textContent.trim() === "";
//       const contentEmpty = !content || content.textContent.trim() === "";

//       if (!(titleEmpty && contentEmpty)) {
//         allEmpty = false; // Found at least one accordion with data
//       }
//     });

//     // Hide section4 if all accordions are empty
//     if (allEmpty) {
//       section4.style.display = "none";
//     }
//   }
// });


document.addEventListener("DOMContentLoaded", function () {
  const section1 = document.getElementById("shopify-section-template--15328510509105__mp_image_with_text_rRCHcH");

  if (section1) {
    const subTitle = section1.querySelector(".sub_title");
    const title = section1.querySelector(".title");
    const desc = section1.querySelector(".desc");
    const image = section1.querySelector(".mpthumbnail img");

    const hasSubTitle = subTitle && subTitle.textContent.trim().length > 0;
    const hasTitle = title && title.textContent.trim().length > 0;
    const hasDesc = desc && desc.textContent.trim().length > 0;
    const hasImage = image && image.src && image.src.trim() !== "";

    // If all are empty/missing, hide the section1
    if (!hasSubTitle && !hasTitle && !hasDesc && !hasImage) {
      section1.style.display = "none";
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const section2 = document.getElementById("shopify-section-template--15328510509105__section_NBrity");

  if (section2) {
    const headingEl = section2.querySelector(".heading-block");
    const headingEmpty = !headingEl || headingEl.textContent.trim().length === 0;

    if (headingEmpty) {
      section2.style.display = "none";
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const section3 = document.getElementById("shopify-section-template--15370801020977__section_rbtmeE");

  if (section3) {
    const headingEl = section3.querySelector(".heading-block");
    const headingEmpty = !headingEl || headingEl.textContent.trim().length === 0;

    if (headingEmpty) {
      section3.style.display = "none";
    }
  }
});



  document.querySelectorAll(".shopify-section").forEach(section => {
    if (section.querySelector(".azo_accordion")) {
      // If NO .azo_accordion_content exists inside
      if (!section.querySelector(".azo_accordion_content")) {
        section.style.display = "none";
      }
    }
  });



window.wrapSpecialCharsInSup = function(selectors, chars) {
  try {
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        let html = el.innerHTML;
        chars.forEach(char => {
          const wrapped = `<sup>${char}</sup>`;
          if (!html.includes(wrapped)) {
            const regex = new RegExp(`(?<!<sup>)${char}(?!</sup>)`, 'g');
            html = html.replace(regex, wrapped);
          }
        });
        if (!el.querySelector('img')) {
          el.innerHTML = html;
        }
      });
    });
  } catch (err) {
  }
};
window.supSelectors = [
  '.product__title h1',
  '.box_sub_title',
  'p',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'a',
  '.heading-block',
  '.azo_card_bottom h5'
];

window.supChars = ['®', '†', '§'];

wrapSpecialCharsInSup(supSelectors, supChars);
